import {ApiShipmentRepository} from '@infra/domain/model/Shipment/ApiShipmentRepository';
import {GetShipmentByOrderReference} from '@application/Shipment/GetShipmentByOrderReference';
import {GetShipmentByServiceId} from '@application/Shipment/GetShipmentByServiceId';

export const ShipmentApplication = {
  getShipmentByOrderReference: GetShipmentByOrderReference(ApiShipmentRepository),
  getShipmentByServiceId: GetShipmentByServiceId(ApiShipmentRepository),
};
